import { render, staticRenderFns } from "./FornecedorRestricao.vue?vue&type=template&id=207bf14c&scoped=true"
import script from "./FornecedorRestricao.vue?vue&type=script&lang=js"
export * from "./FornecedorRestricao.vue?vue&type=script&lang=js"
import style0 from "./FornecedorRestricao.vue?vue&type=style&index=0&id=207bf14c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207bf14c",
  null
  
)

export default component.exports